var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { SearchStatus } from '@/overmind/search/state';
import SearchNotFoundHeader from 'modules/search/components/SearchNotFoundHeader.vue';
import { json } from 'overmind';
let CloundProvider = class CloundProvider extends Vue {
    constructor() {
        super(...arguments);
        this.keys = this.cloundProvider.map(item => this.handlerKey(item));
        this.values = this.cloundProvider.map(item => {
            return {
                name: this.handlerKey(item),
                y: item.doc_count,
            };
        });
        this.chartOptions = {
            chart: {
                type: 'column',
            },
            title: {
                text: '',
            },
            xAxis: {
                title: '',
                categories: json(this.keys),
            },
            yAxis: {
                title: null,
                labels: {
                    formatter: function () {
                        // @ts-ignore TS2349: property inexistent
                        return this.value + '%';
                    },
                },
            },
            legend: {
                enabled: false,
            },
            plotOptions: {
                column: {
                    pointPadding: -0.2,
                },
            },
            tooltip: {
                headerFormat: '<span>{series.name}</span>',
                pointFormat: '<span style="font-weight: bold">{point.name}</span>: {point.y}%',
            },
            series: [
                {
                    name: '',
                    // @ts-ignore TS2349: property inexistent
                    data: json(this.values),
                    color: '#339FFF',
                },
            ],
            credits: false,
        };
    }
    cloundProviderChanged(current) {
        this.chartOptions.xAxis.categories = current.map(item => item.key);
        this.chartOptions.series[0].data = current.map(item => {
            return {
                name: this.handlerKey(item),
                y: item.doc_count,
            };
        });
    }
    handlerKey(value) {
        if (value.key !== '') {
            const newKey = value.key[0].toUpperCase() + value.key.slice(1).toLowerCase();
            return newKey.replace(/_/g, ' ');
        }
        else {
            return '';
        }
    }
};
__decorate([
    Prop({ default: SearchStatus.NOT_RECEIVED })
], CloundProvider.prototype, "createSearchState", void 0);
__decorate([
    Prop({ default: () => [] })
], CloundProvider.prototype, "cloundProvider", void 0);
__decorate([
    Prop({ default: 1 })
], CloundProvider.prototype, "page", void 0);
__decorate([
    Watch('cloundProvider')
], CloundProvider.prototype, "cloundProviderChanged", null);
CloundProvider = __decorate([
    Component({
        components: {
            SearchNotFoundHeader,
        },
    })
], CloundProvider);
export default CloundProvider;
